import { render, staticRenderFns } from "./VFeatureVirtualTable.vue?vue&type=template&id=7471db4c&scoped=true"
import script from "./VFeatureVirtualTable.vue?vue&type=script&lang=js"
export * from "./VFeatureVirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VFeatureVirtualTable.vue?vue&type=style&index=0&id=7471db4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471db4c",
  null
  
)

export default component.exports